export type OnMarsCommonMistake = {
  id: string;
  title: string;
  body: string;
  warnings?: string[];
  tags: string[];
};

/** Typowe błędy z pakietu MVP — uzupełnienie, nie zamiennik instrukcji. */
export const onMarsCommonMistakes: OnMarsCommonMistake[] = [
  {
    id: 'mistake-01',
    title: 'Wydawanie świeżo zdobytych kryształów',
    body: 'Kryształy zdobyte w turze są niedostępne do początku następnej tury.',
    warnings: ['To jeden z najczęstszych błędów pierwszej partii.'],
    tags: ['błąd', 'kryształ'],
  },
  {
    id: 'mistake-02',
    title: 'Budowa poza zasięgiem bota',
    body: 'Przed budową wskaż bota, którego strefa obejmuje wybrany heks.',
    tags: ['błąd', 'bot', 'budowa'],
  },
  {
    id: 'mistake-03',
    title: 'Pominięcie technologii kompleksu',
    body: 'Przy połączeniu budynków tego samego typu sprawdź wymaganą technologię i jej poziom.',
    tags: ['błąd', 'kompleks', 'technologia'],
  },
  {
    id: 'mistake-04',
    title: 'Branie zbyt wielu projektów',
    body: 'Każdy niezbudowany projekt może dać punkty ujemne. Nie traktuj natychmiastowej premii jako darmowej.',
    tags: ['błąd', 'projekt'],
  },
  {
    id: 'mistake-05',
    title: 'Zapomnienie o nagrodzie właściciela technologii',
    body: 'Gdy używasz cudzej technologii, rozpatrz premię jej właściciela.',
    tags: ['błąd', 'technologia'],
  },
  {
    id: 'mistake-06',
    title: 'Złe rozpatrzenie wzrostu kolonii',
    body: 'Przy każdym wzroście wykonaj pełną listę: przesuń znacznik, uzupełnij technologie i magazyn, dodaj statki oraz rozpatrz efekty poziomu.',
    tags: ['błąd', 'poziom kolonii'],
  },
  {
    id: 'mistake-07',
    title: 'Traktowanie łazika jak bota',
    body: 'Łazik eksploruje; bot wyznacza zasięg budowy.',
    tags: ['błąd', 'łazik', 'bot'],
  },
  {
    id: 'mistake-08',
    title: 'Nieplanowanie strony na następną rundę',
    body: 'Przed fazą wahadłowca sprawdź, jakie akcje będą ci potrzebne w następnej rundzie.',
    tags: ['błąd', 'wahadłowiec'],
  },
  {
    id: 'mistake-09',
    title: 'Odzyskiwanie kolonistów ze strony docelowej',
    body: 'Podczas podróży zbierasz kolonistów z pól akcji strony, którą opuszczasz, oraz ze strefy pracy. Lecąc na powierzchnię zbierasz orbitę; lecąc na orbitę zbierasz kolonię.',
    warnings: ['FAQ i rozdziały podróży muszą być zgodne — nigdy nie zbieraj strony docelowej.'],
    tags: ['błąd', 'podróż', 'koloniści'],
  },
];
